/* istanbul ignore file */
export const storeNamespace = 'CMW_MHB2B_NAMESPACE';
